module.exports = __webpack_public_path__ + "img/teleradio-sm.41a86aed.png";